export enum LayerNumberModes {
  increase = 'increase',
  default = 'default',
}
